import _keyBy from 'lodash/keyBy';

// url to the layer of interest to query
import {
  ATTRIBUTE_FIELD_FOR_ESTIMATES,
  ATTRIBUTE_FIELD_FOR_POPULATION,
  ATTRIBUTE_FILED_FOR_UNCERTAINTY,
  RASTER_FIELD_FOR_ESTIMATES,
  RASTER_FIELD_FOR_POPULATION,
  RASTER_FILED_FOR_UNCERTAINTY,
} from './attributeFields.configs';
import { SidebarMapFilterFieldsType, SidebarMapFiltersType } from './types';

export const ADMIN_1_VECTOR_BOUNDARIES =
  'https://gis.dhsprogram.com/arcgis/rest/services/Geometry/SDR_Regions/MapServer/0';
export const ADMIN_2_VECTOR_BOUNDARIES =
  'https://gis.dhsprogram.com/arcgis/rest/services/Development/Admin2Testing_boundaries/MapServer/0';
export const SURVEY_RASTER_SERVICE = 'https://gis.dhsprogram.com/arcgis/rest/services/Admin2SDR';

export const SERVICES__GEOMETRY__BASEMAP_REGIONS_TEST__MAP_SERVER__URL =
  'https://gis.dhsprogram.com/arcgis/rest/services/Geometry/Basemap_regions_TEST/MapServer/6';

export const GO_TO_OPTIONS = {
  animate: true,
  duration: 1000,
};

export const NO_VALUE = -1;
export const NO_VALUE_LABEL = 'No Data';
export const NO_VALUE_COLOR = '#ccc';
export const ADMIN_1_BOUNDARY_OUTLINE_COLOR = '#1c1c1c';
export const ADMIN_1_BOUNDARY_OUTLINE_WIDTH = 2;
export const ADMIN_2_BOUNDARY_OUTLINE_COLOR = ADMIN_1_BOUNDARY_OUTLINE_COLOR;
export const ADMIN_2_BOUNDARY_OUTLINE_WIDTH = ADMIN_1_BOUNDARY_OUTLINE_WIDTH;
export const ADMIN_2_OUTLINE_COLOR = '#6b6b6b';
export const ADMIN_2_REFERENCE_OUTLINE_COLOR = ADMIN_1_BOUNDARY_OUTLINE_COLOR;
export const HIGHLIGHT_COLOR = 'rgba(30,255,255,1)';
export const HIGHLIGHT_COLOR_OPACITY = 'rgba(30,255,255,0.15)';

export const ADMIN_1_BOUNDARY_SYMBOL = {
  type: 'simple-line',
  color: ADMIN_1_BOUNDARY_OUTLINE_COLOR,
  width: ADMIN_1_BOUNDARY_OUTLINE_WIDTH,
};

export const ADMIN_2_BOUNDARY_SYMBOL = {
  type: 'simple-line',
  color: ADMIN_2_BOUNDARY_OUTLINE_COLOR,
  width: ADMIN_2_BOUNDARY_OUTLINE_WIDTH,
};

export const ADMIN__Admin1 = 'Admin1';
export const ADMIN__Admin2 = 'Admin2';
export const ADMIN__5X5km = '5x5km';
export const RASTER_LAYER_VALUE_KEY = 'Classify.Pixel Value';
export const DHSREGEN = 'DHSREGEN';
export const ADMIN1_REGION_ID_FIELD = 'REG_ID';
export const ADMIN_2_INDICATOR = 'IndicatorID';
export const ADMIN_2_SURVEY_TYPE = 'SurveyType';
export const ADMIN_2_YEAR = 'year';

export const SIDEBAR_MAP_ADMIN_FILTERS: SidebarMapFiltersType[] = [
  {
    label: 'Admin 1',
    value: ADMIN__Admin1,
    tooltip: 'Largest subnational boundaries within a country. Direct estimates at this level.',
  },
  {
    label: 'Admin 2',
    value: ADMIN__Admin2,
    tooltip: 'Second largest subnational boundaries within a country. Modeled estimates at this level.',
  },
  {
    label: '5 x 5 km',
    value: ADMIN__5X5km,
    tooltip: '5 x 5 km pixels from a uniform grid within a country. Modeled estimates at this level.',
  },
];

export const FILTER_FIELDS_ESTIMATES: string = 'Estimates';
export const FILTER_FIELDS_POPULATION: string = 'Population';
export const FILTER_FIELDS_UNCERTAINTY: string = 'Uncertainty';
export const SIDEBAR_MAP_FILTER_FIELDS: SidebarMapFilterFieldsType[] = [
  {
    label: FILTER_FIELDS_ESTIMATES,
    value: ATTRIBUTE_FIELD_FOR_ESTIMATES,
    raster_type: RASTER_FIELD_FOR_ESTIMATES,
    raster_type_multiplier: 100,
    tooltip: 'Estimates (percentage or rate) for the selected indicator.',
    format: (value) => (value ? `${value.toFixed(DATA_VALUE_PRECISION)}%` : NO_VALUE_LABEL),
  },
  {
    label: FILTER_FIELDS_POPULATION,
    value: ATTRIBUTE_FIELD_FOR_POPULATION,
    raster_type: RASTER_FIELD_FOR_POPULATION,
    raster_type_multiplier: 1,
    tooltip: 'Population count affected for each percentage indicator.',
    format: (value) => (value ? `${value.toLocaleString()}` : NO_VALUE_LABEL),
  },
  {
    label: FILTER_FIELDS_UNCERTAINTY,
    value: ATTRIBUTE_FILED_FOR_UNCERTAINTY,
    raster_type: RASTER_FILED_FOR_UNCERTAINTY,
    raster_type_multiplier: 100,
    tooltip: 'Width of the 95% uncertainty interval (upper bound – lower bound).',
    format: (value) => (value ? `${value.toFixed(DATA_VALUE_PRECISION)}%` : NO_VALUE_LABEL),
  },
];

export const SIDEBAR_MAP_FILTER_FIELDS_OBJECT = _keyBy(SIDEBAR_MAP_FILTER_FIELDS, 'value');

export const RASTER_URL_CONFIG: any = {
  [ATTRIBUTE_FIELD_FOR_ESTIMATES]: RASTER_FIELD_FOR_ESTIMATES,
  [ATTRIBUTE_FIELD_FOR_POPULATION]: RASTER_FIELD_FOR_POPULATION,
  [ATTRIBUTE_FILED_FOR_UNCERTAINTY]: RASTER_FILED_FOR_UNCERTAINTY,
};

export const ADMIN1_BOUNDARIES_LAYER_ID = 'Admin1_boundaries_layer';
export const ADMIN2_BOUNDARIES_LAYER_ID = 'Admin2_boundaries_layer';
export const ADMIN_2_REF_FEATURE_LAYER_ID = 'admin2ReferenceFeatureLayer';

export const DATA_VALUE_PRECISION = 1;
